module.exports = __webpack_public_path__ + "media/images/avatar_empty-110b4a3b.svg";